export enum CoercionType {
    Text = 0,
    Html = 3,
}
export interface AppendOnSend {
    txt: string;
    typ: CoercionType;
    id: string;
}

export interface AppendOnSendViewState {
    appendOnSend: AppendOnSend[];
}

export function createAppendOnSendViewState(
    appendOnSend: AppendOnSend[] = []
): AppendOnSendViewState {
    return {
        appendOnSend: appendOnSend,
    };
}
